export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["欢迎奖金"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["试试你的运气！"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["你赢了"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["转动轮盘并获得测试资金来探索所有平台功能。"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["这些资金用于测试。"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["深入体验所有功能。"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["转动"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["领取"])}
}